const dsHeader = (($) => {

    const header = 'header#mini-header',
        slider = 'div.header__slider'

    function headerScroll() {
        if (window.innerWidth <= 768) {
            $(slider).fadeOut();
            document.body.scrollTop > 80 || document.documentElement.scrollTop > 80 ? promoHide() : promoShow();
        } else {
            $(slider).fadeIn();
        }
    }

    function promoHide() {
        $(`${header} .search`).css('width', '80%');
        if ($(`${header} div#container`).length > 0) {
            $(`${header} #container`).css('flexDirection', 'row').css('justifyContent', 'space-between').css('alignItems', 'center');
        }
        if ($(`${header} div#category_header`).length > 0) {
            $(header).css('height', '7.5rem');
        } else {
            $(header).css('height', '3.5rem');
        }
        $(`${header} #promo-banner`).css('display', 'none');
        $(`${header} #logo-icon-mobile`).css('display', 'block');
        $(`${header} #logo-mobile`).css('display', 'none');
    }

    function promoShow() {
        $(`${header} .search`).css('width', '100%');
        if ($(`${header} div#container`).length > 0) {
            $(`${header} #container`).css('flexDirection', 'column').css('alignItems', 'flex-start');
        }
        if ($(`${header} div#category_header`).length > 0) {
            $(header).css('height', '7.5rem');
        } else {
            $(header).css('height', '7rem');
        }
        $(`${header} #promo-banner`).css('display', 'flex');
        $(`${header} #logo-icon-mobile`).css('display', 'none');
        $(`${header} #logo-mobile`).css('display', 'block');
    }

    function resize() {
        $(`${header} #logo-icon-mobile`).css('display', 'none');
        $(`${header} #logo-mobile`).css('display', 'none');
        if (category_page()) {
            $(`${header} #container`).removeAttr('style');
        }
    }

    function header_small() {
        return ['tpl','account', 'account1', 'checkout'].includes(doorstep.page_type) || doorstep.page_type === 'product' && doorstep.product_detail;
    }

    function category_page() {
        return doorstep.page_type === 'product' && !doorstep.product_detail;
    }

    $(document).ready(function () {

        headerScroll();

        $('button#email_submit, button#password_reset').on('click', function (e) {
            e.preventDefault();
            const el = $(this).closest('form');
            $(el).find('div.error-msg-box').remove();
            if ($(el).attr('id') === 'form_login') {
                $(el).submit();
            } else {
                dsValidate.reCAPTCHAVerify().done(function (response) {
                    if (response.verify.success) {
                        $(el).submit();
                    } else {
                        $(el).prepend('<div class="error-msg-box">Please verify reCAPTCHA</div>');
                    }
                });
            }
        });

    });

    window.addEventListener('scroll', function () {
        headerScroll();
    }, true);

    window.addEventListener('resize', function () {
        resize();
    }, true);

    function sign_out() {
        setTimeout(sign_out,1000);
        if (dsValidate.payment_made()) {
            location.href = dsUtilities.urlLogout();
        }
    }

    $(document).ready(function () {
        $('div#acc-orders-nav a#signin').on('click', function () {
            sign_out();
        });
    });

})(jQuery);